import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="brut-spinner" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  if (role && user.role !== role) {
    // Redirect to the correct home for the user's role
    const home = user.role === "admin" ? "/admin" : "/usher";
    return <Navigate to={home} replace />;
  }
  return children;
}
